export default "__VITE_ASSET__DShi26_N__"